
      import { ConsoleLogger, checkLoafSupport } from "/main.js";

      const logger = new ConsoleLogger(document.getElementById("output"));
      const heroContainer = document.getElementById("heroContainer");
      const lcpInfo = document.getElementById("lcpInfo");
      const timeline = document.getElementById("timeline");
      const loadBtn = document.getElementById("loadBtn");
      const loadSlowBtn = document.getElementById("loadSlowBtn");
      const clearBtn = document.getElementById("clearBtn");

      checkLoafSupport();

      let lcpTime = null;
      let lcpElement = null;
      const events = [];

      // Detectar modo de carga
      const urlParams = new URLSearchParams(window.location.search);
      const mode = urlParams.get("mode");

      // Observer de LCP
      const lcpObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const lastEntry = entries[entries.length - 1];

        lcpTime = lastEntry.renderTime || lastEntry.loadTime;
        lcpElement = lastEntry.element;

        logger.log("");
        logger.log("🎯 LCP detectado!");
        logger.log(`   • Tiempo: ${lcpTime.toFixed(2)}ms`);
        logger.log(`   • Elemento: ${lastEntry.element?.tagName}`);
        logger.log(`   • Size: ${lastEntry.size}px`);
        logger.log("");

        // Rating
        let rating = "good";
        let ratingText = "🟢 Bueno";
        if (lcpTime > 4000) {
          rating = "poor";
          ratingText = "🔴 Malo";
        } else if (lcpTime > 2500) {
          rating = "needs-improvement";
          ratingText = "🟡 Necesita mejora";
        }

        lcpInfo.innerHTML = `
        <div class="metric ${rating}">
          ${lcpTime.toFixed(2)}ms
          <small style="display: block; font-weight: normal; margin-top: 4px;">
            ${ratingText}
          </small>
        </div>
      `;

        events.push({
          type: "lcp",
          time: lcpTime,
          label: `LCP: ${lcpTime.toFixed(2)}ms`,
        });

        // Analizar LoAFs
        setTimeout(() => analyzeBlockingFrames(), 100);
      });

      try {
        lcpObserver.observe({
          type: "largest-contentful-paint",
          buffered: true,
        });
      } catch (e) {
        logger.error("LCP API no soportada");
      }

      // Observer de LoAF
      const loafObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          events.push({
            type: "loaf",
            time: entry.startTime,
            duration: entry.duration,
            blockingDuration: entry.blockingDuration,
            scripts: entry.scripts,
            entry: entry,
          });
        }
      });

      try {
        loafObserver.observe({
          type: "long-animation-frame",
          buffered: true,
        });
      } catch (e) {
        logger.error("LoAF no soportado");
      }

      // Analizar frames que bloquearon LCP
      function analyzeBlockingFrames() {
        if (!lcpTime) return;

        logger.log("🔍 Analizando frames que bloquearon LCP...");
        logger.log("");

        // Filtrar LoAFs que ocurrieron antes del LCP
        const blockingFrames = events
          .filter((e) => e.type === "loaf" && e.time < lcpTime)
          .sort((a, b) => a.time - b.time);

        if (blockingFrames.length === 0) {
          logger.log("✅ No se detectaron frames lentos antes del LCP");
          logger.log("");
          renderTimeline();
          return;
        }

        logger.warn(`⚠️  ${blockingFrames.length} frame(s) lento(s) detectado(s) antes del LCP`);
        logger.log("");

        const totalBlocking = blockingFrames.reduce((sum, f) => sum + f.blockingDuration, 0);
        logger.log(`📊 Tiempo total de bloqueo: ${totalBlocking.toFixed(2)}ms`);
        logger.log("");

        // Detallar cada frame
        blockingFrames.forEach((frame, index) => {
          logger.log(`Frame #${index + 1}:`);
          logger.log(`   • Inicio: ${frame.time.toFixed(2)}ms`);
          logger.log(`   • Duración: ${frame.duration.toFixed(2)}ms`);
          logger.log(`   • Bloqueo: ${frame.blockingDuration.toFixed(2)}ms`);

          if (frame.scripts && frame.scripts.length > 0) {
            logger.log(`   • Scripts ejecutados: ${frame.scripts.length}`);

            frame.scripts.forEach((script, i) => {
              logger.log(
                `     ${i + 1}. ${script.sourceFunctionName || "anonymous"} (${script.duration.toFixed(2)}ms)`,
              );
            });
          }

          logger.log("");
        });

        // Impacto estimado
        const lcpDelay = (totalBlocking / lcpTime) * 100;
        logger.warn(`💡 Impacto estimado: ${lcpDelay.toFixed(1)}% del tiempo de LCP fue bloqueo`);
        logger.log("");

        renderTimeline();
      }

      // Renderizar timeline visual
      function renderTimeline() {
        if (events.length === 0) {
          timeline.innerHTML =
            '<p style="color: var(--color-text-secondary); text-align: center;">No hay eventos aún</p>';
          return;
        }

        // Ordenar por tiempo
        const sortedEvents = [...events].sort((a, b) => a.time - b.time);

        let html = "";

        sortedEvents.forEach((event) => {
          if (event.type === "lcp") {
            // Calcular rating del LCP según umbrales de Core Web Vitals
            let lcpRating = "good";
            if (event.time > 4000) {
              lcpRating = "poor";
            } else if (event.time > 2500) {
              lcpRating = "needs-improvement";
            }

            html += `
            <div class="timeline-item lcp ${lcpRating}">
              <div class="timeline-label">LCP (Largest Contentful Paint)</div>
              <div class="timeline-value">${event.time.toFixed(2)}ms</div>
            </div>
          `;
          } else if (event.type === "loaf") {
            const isBlocking = lcpTime && event.time < lcpTime;
            const className = isBlocking ? "timeline-item blocking" : "timeline-item";

            html += `
            <div class="${className}">
              <div class="timeline-label">
                ${isBlocking ? "🔴 Long Frame (bloqueando LCP)" : "Long Frame"}
              </div>
              <div class="timeline-value">
                ${event.time.toFixed(2)}ms - ${(event.time + event.duration).toFixed(2)}ms
                (bloqueo: ${event.blockingDuration.toFixed(2)}ms)
              </div>
            </div>
          `;
          }
        });

        timeline.innerHTML = html;
      }

      // Cargar hero image
      function loadHeroImage() {
        const hero = document.createElement("img");
        hero.className = "hero-image";
        hero.alt = "Calella de Palafrugell - Hero Image";

        // Imagen real de ~3MB sin optimizar (caso común en producción)
        hero.src = "/assets/Calella-de-Palafrugell.png";

        heroContainer.innerHTML = "";
        heroContainer.appendChild(hero);

        hero.onload = () => {
          hero.classList.add("loaded");
        };
      }

      // Botones ahora recargan la página con query params
      loadBtn.addEventListener("click", () => {
        window.location.href = "?mode=fast";
      });

      loadSlowBtn.addEventListener("click", () => {
        window.location.href = "?mode=slow";
      });

      clearBtn.addEventListener("click", () => {
        window.location.href = window.location.pathname;
      });

      // Carga automática basada en URL params
      if (mode === "fast") {
        logger.log("🚀 Carga rápida iniciada");
        logger.log("📌 Sin scripts bloqueantes antes del LCP");
        logger.log("");
        loadHeroImage();
      } else if (mode === "slow") {
        logger.log("🚀 Carga lenta iniciada");
        logger.log("📌 Scripts bloqueantes ejecutados ANTES del parsing del HTML");
        logger.log("⚠️  Revisa la consola del navegador para ver los logs de bloqueo");
        logger.log("");
        loadHeroImage();
      } else {
        // Estado inicial
        logger.log('👋 Haz clic en "Carga rápida" o "Carga lenta"');
        logger.log("📌 La página se recargará y ejecutará scripts bloqueantes reales");
        logger.log("🎯 Observa la diferencia en el LCP entre ambas cargas");
        logger.log("");
      }
    